import React from 'react';
import Assets from '../../Assets';

export default class EditorConfigurationStatusDropdown extends React.Component {
    state = {
        open: false,
        currentItemID: 0,

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            currentItemID: nextProps.currentItem.id
        })
    }

    onButtonClick = () => {
        this.setState({
            open: !this.state.open
        })
    }

    onItemClick = item => {
        this.setState({
            open: false,
            currentItemID: item.id
        }, () => {

        })

        if (this.props.onItemClick) {
            this.props.onItemClick(item)
        }
    }

    render() {
        const rootClassNames = ['dropdown', 'dropdown--react', 'configuration-status-dropdown']
        if (this.state.open) {
            rootClassNames.push('dropdown--open')
        }

        return (
            <div className={rootClassNames.join(' ')}>
                {this.renderButton()}
                {this.renderBody()}
            </div>
        )
    }

    renderButton = () => {

        const currentItem = this.props.items.find(x => x.id === this.state.currentItemID)

        return (
            <div className="dropdown-button" onClick={this.onButtonClick}>
                <div className="dropdown-button-body">
                    {this.renderDotColor(currentItem)}
                    <div>{currentItem.label}</div>
                </div>

                <img src={Assets.arrowDown}/>
            </div>
        )
    }

    renderDotColor = (item) => {

        return (<div className="dot-color" style={{backgroundColor: item.color}}></div>)


    }

    renderBody = () => {
        const itemsToRender = this.props.items.filter(x => x.id !== this.state.currentItemID)

        return (
            <div className="dropdown-body" style={{display: this.state.open ? 'block' : 'none'}}>
                {itemsToRender.map(this.renderItem)}
            </div>
        )
    }

    renderItem = (item) => {
        return (
            <div key={item.id} className="dropdown-item" onClick={e => this.onItemClick(item)}>
                {this.renderDotColor(item)}
                <div>{item.label}</div>
            </div>
        )
    }
}